import React, { useState } from "react";
import "./HomeRouters.scss";
import { NavLink } from "react-router-dom";
import { routers, iptv, cameras } from "../../../Modules/RouterModule/routersData";
import RouterCard from "../../Router/RouterSlider/RouterCards/RouterCard/RouterCard";
import Form from "../../General/Form/Form";

/*
  Единственный блок оборудования на главной. Данные и карточка те же, что
  на /router, поэтому витрина не разъезжается с каталогом.
  anchor — id секции на /router, туда же ведёт «Все устройства».
*/
const TABS = [
  { name: "Роутеры", data: routers, anchor: "router" },
  { name: "IP TV", data: iptv, anchor: "Iptv" },
  { name: "Камеры", data: cameras, anchor: "camera" },
];

const CARDS_ON_HOME = 3;

const HomeRouters = () => {
  const [tab, setTab] = useState(0);
  const [active, setActive] = useState(false);

  const current = TABS[tab];
  // Показываем то, что в наличии. Если в наличии нет ничего (у IP TV сейчас
  // ровно одна позиция и она распродана), вкладка не остаётся пустой —
  // рисуем товар как есть, с его собственной плашкой «Нет в наличии».
  const inStock = current.data.filter((e) => e.in_stock !== false);
  const items = (inStock.length ? inStock : current.data).slice(0, CARDS_ON_HOME);

  // ←/→ переключают вкладки с клавиатуры; фокус уезжает за активной
  const onKeyDown = (event) => {
    const step = event.key === "ArrowRight" ? 1 : event.key === "ArrowLeft" ? -1 : 0;
    if (!step) return;
    event.preventDefault();
    const next = (tab + step + TABS.length) % TABS.length;
    setTab(next);
    const buttons = event.currentTarget.querySelectorAll("button");
    if (buttons[next]) buttons[next].focus();
  };

  return (
    <div className="homeRouters_container" id="equipment">
      <div className="homeRouters_block">
        <div className="homeRouters_head">
          <h2>Оборудование</h2>
          <NavLink to={"/router#" + current.anchor} className="homeRouters_all">
            Все устройства <span aria-hidden="true">→</span>
          </NavLink>
        </div>

        <div className="homeRouters_tabs" onKeyDown={onKeyDown}>
          {TABS.map((e, index) => (
            <button
              type="button"
              key={e.name}
              className={
                "homeRouters_tab" + (tab === index ? " homeRouters_tab--active" : "")
              }
              aria-pressed={tab === index}
              onClick={() => setTab(index)}
            >
              {e.name}
            </button>
          ))}
        </div>

        <div className="homeRouters_cards">
          {items.map((e) => (
            <RouterCard
              key={current.anchor + "-" + e.id}
              data={e}
              setActive={setActive}
              variant="compact"
            />
          ))}
        </div>
      </div>

      {active && (
        <div className="form_container">
          <div className="form_block">
            <Form show={true} setShowModal={setActive} />
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeRouters;
